export enum RoleType {
	TRUSSTOR_ADMIN = 'TRUSSTOR_ADMIN',
	PROJECT_ADMIN = 'PROJECT_ADMIN',
	MANAGER = 'MANAGER',
	EXECUTIVE = 'EXECUTIVE',
	VIEWER = 'VIEWER',
}
